module.exports = __webpack_public_path__ + "images/stickers/pete-alert.e021d24356b3f75742a7.png";